<template>
  <div class="case-page">
    <section class="banner">
      <h1>行业案例</h1>
      <p>九恒智电为超过4000家客户提供服务</p>
    </section>
    <div class="topic">
      <div class="ctn">
        <h2>党政军客户形成灯塔效应<br/>社会客户覆盖十大行业</h2>
        <p>公司服务覆盖十余个行业，涉及电网及央企、政府事业单位、数据中心、科研院校、医院、商业办公、工业企业、交通运输、居民住宅、酒店餐饮。</p>
      </div>
    </div>
    <ul class="ctn">
      <li :class="delayed ? 'scrolled' : ''">
        <img src="@/assets/c2.jpg"/>
        <h3>参与国家重大活动</h3>
        <p>多年来，九恒智电受委托参与国家各类重大活动的重要场所电力保障工作，公司凭借多年在电力运营方面丰富的建设与运营经验，高标准完成工作任务，受到了社会各界的广泛认可。</p>
        <ul>
          <li>2014年APEC峰会</li>
          <li>2015年阅兵仪式</li>
          <li>2019年“一带一路”高峰论坛</li>
          <li>2022年北京冬奥会</li>
        </ul>
      </li>
      <li :class="scrolledTop >= 460 ? 'scrolled' : ''">
        <img src="@/assets/c3.jpg"/>
        <h3>产业园区</h3>
        <p>以实际情况为出发，结合业务需求，九恒为产业园区提供从电网规划、电力负荷预测到电源和电力网发展规划等服务，向产业园区客户提供面向未来的电力系统发展和建设方案。</p>
        <ul>
          <li>北京经济技术开发区</li>
        </ul>
      </li>
      <li :class="scrolledTop >= 920 ? 'scrolled' : ''">
        <img src="@/assets/c4.jpg"/>
        <h3>大型综合体</h3>
        <p>九恒智电为解决大型综合体用电需求，提供定制一体化的解决方案，从用电设计规划、电力实施、设备安装再到智慧化运维，覆盖综合体用电配套全流程，优化能源利用效率，为企业降本增效。</p>
        <ul>
          <li>国家大剧院</li>
          <li>北京大兴国际机场</li>
          <li>国家会议中心</li>
        </ul>
      </li>
      <li :class="scrolledTop >= 1380 ? 'scrolled' : ''">
        <img src="@/assets/c5.jpg"/>
        <h3>院校&研究机构</h3>
        <p>九恒智电为学校与研究机构开发出完备的配套解决方案。公司拥有丰富的电力设计、实施与运维经验，与学校和研究机构的多样性需求相匹配。在高效完成任务的同时，保证客户用电无忧。</p>
        <ul>
          <li>故宫博物院</li>
          <li>北京理工大学</li>
          <li>清华大学光华路校区</li>
          <li>中国计量科学院昌平实验基地</li>
        </ul>
      </li>
      <li :class="scrolledTop >= 1840 ? 'scrolled' : ''">
        <img src="@/assets/c6.jpg"/>
        <h3>数据中心</h3>
        <p>为解决数据中心高密度供电的稳定性需求，九恒智电多年来不断完善设计方案，从智电设计到智慧运维服务，提出针对数据中心用电模型的独有解决方案，组建了一支稳定、专业、高水平的数据中心电力保障运维管理团队，为客户数据中心的平稳安全用电保驾护航。</p>
        <ul>
          <li>中国人寿数据中心</li>
          <li>秦淮数据</li>
        </ul>
      </li>
      <li :class="scrolledTop >= 2300 ? 'scrolled' : ''">
        <img src="@/assets/c7.jpg"/>
        <h3>医院</h3>
        <p>九恒智电为医院客户提供配电设施的全面托管运营服务，结合可视化云平台实现医院配电系统7*24h全方位运营管理。结合医院配电系统管理规范，九恒帮助客户搭建应急保障体系，确保用电稳定安全。</p>
        <ul>
          <li>北京朝阳医院</li>
          <li>北京友谊医院</li>
          <li>北京天坛医院</li>
        </ul>
      </li>
      <!-- <li :class="scrolledTop >= 2760 ? 'scrolled' : ''">
        <img src="@/assets/c8.jpg"/>
        <h3>能源企业</h3>
        <p>以碳资产管理为依托，依托多年智电设计与配网经验，九恒智电为能源企业提供针对性的定制方案，以链条式的新型电力系统解决方案和碳中和服务，促进能源企业高效、低碳转型发展。</p>
        <ul>
          <li>国投伊犁能源开发有限公司</li>
          <li>小米</li>
          <li>理想汽车</li>
        </ul>
      </li> -->
     </ul>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      curImg: 0,
      scrolledTop: 0,
      delayed: false
    }
  },
  created() {
    document.body.addEventListener('scroll', this.scrolling)
    setTimeout(() => {
      this.delayed = true
    }, 300)
  },
  methods: {
    scrolling() {
      const s = document.body.scrollTop
      this.scrolledTop = s > this.scrolledTop ? s : this.scrolledTop
    }
  },
  destroyed() {
    document.body.removeEventListener('scroll', this.scrolling)
  }
}
</script>
